/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SecurityScheme } from '../../openapi/v3/models/Oas30SecurityScheme';
import { ChangeSecuritySchemeCommand } from './ChangeSecuritySchemeCommand';
import { Oas30Components } from '../../openapi/v3/models/Oas30Components';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';

/**
 * @author eric.wittmann@gmail.com
 * @extends ChangeSecuritySchemeCommand
 * @class
 */
export class ChangeSecuritySchemeCommand_30 extends ChangeSecuritySchemeCommand {
    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super(scheme);
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand#getSchemeFromDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {SecurityScheme}
     */
    getSchemeFromDocument(document : Document) : SecurityScheme {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(this.isNullOrUndefined(doc30.components)) {
            return null;
        }
        return doc30.components.getSecurityScheme(this._schemeName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand#nullScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} scheme
     */
    nullScheme(scheme : SecurityScheme) {
        super.nullScheme(scheme);
        let scheme30 : Oas30SecurityScheme = <Oas30SecurityScheme>scheme;
        scheme30.$ref = null;
        scheme30.scheme = null;
        scheme30.bearerFormat = null;
        scheme30.flows = null;
        scheme30.openIdConnectUrl = null;
    }
}
ChangeSecuritySchemeCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand_30";
ChangeSecuritySchemeCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




